import cloneDeep from 'lodash/cloneDeep';
import { buildPayloadFromState } from './payloadBuilder';

const onMutated = [
  'applicant/SET_PRIMARY_APPLICANT_DATE_OF_BIRTH',
  'applicant/SET_PRIMARY_APPLICANT_EMAIL_ADDRESS',
  'applicant/SET_PRIMARY_APPLICANT_FIRST_NAME',
  'applicant/SET_PRIMARY_APPLICANT_LAST_NAME',
  'applicant/SET_PRIMARY_APPLICANT_MOBILE_NUMBER',
  'residence/SET_PRIMARY_APPLICANT_CURRENT_ADDRESS_CITY',
  'residence/SET_PRIMARY_APPLICANT_CURRENT_ADDRESS_STATE',
  'residence/SET_PRIMARY_APPLICANT_CURRENT_ADDRESS_STREET',
  'residence/SET_PRIMARY_APPLICANT_CURRENT_ADDRESS_ZIP_CODE',
  'employment/SET_PRIMARY_APPLICANT_GROSS_ANNUAL_INCOME_AT_CURRENT_EMPLOYMENT',
  'vehicle/SET_CURRENT_LENDER',
  'vehicle/SET_CURRENT_MONTHLY_PAYMENT',
  'vehicle/SET_MAKE',
  'vehicle/SET_MILEAGE',
  'vehicle/SET_MODEL',
  'vehicle/SET_TRIM',
  'vehicle/SET_YEAR',
  'global/SET_REASON_FOR_LOAN_CHANGE',
  'global/SET_SUBMISSION_TIME',
  'global/SET_APP_ID'
];

const AutopilotStorePlugin = (window) => {
  return store => {
    store.subscribe((mutation, state) => {
      if (onMutated.includes(mutation.type)) {
        store.dispatch('trackingData/setMarketingAutomationFields', buildPayloadFromState(state));
      }

      if (mutation.type === 'trackingData/ADD_MARKETING_AUTOMATION_FIELD') {
        if (typeof window.Autopilot !== 'undefined') {
          let payload = cloneDeep(state.trackingData.marketingAutomation);

          if (payload.Email) {

            // update existing Autopilot contact based on previously used email
            if (state.applicant.primary.previousEmailAddress !== null) {
              payload['Email'] = state.applicant.primary.previousEmailAddress;

              const newEmail = {
                '_NewEmail': state.applicant.primary.emailAddress
              }

              payload = {...payload, ...newEmail};
            }

            window.Autopilot.run('associate', payload);
          }
        } else {
          console.error('Autopilot failed to load in time for update.');
        }
      }
    });
  };
};

export default AutopilotStorePlugin;
